'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = UIMedia;

var _underscore = require('../utils/underscore');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var ALIGNMENT_TYPES = {
  'start': '',
  'baseline': 'private-media--align-baseline',
  'center': 'private-media--align-middle',
  'end': 'private-media--align-bottom'
};

function UIMedia(props) {
  var align = props.align,
      children = props.children,
      className = props.className,
      collapsed = props.collapsed,
      other = _objectWithoutProperties(props, ['align', 'children', 'className', 'collapsed']);

  return _react2.default.createElement(
    'div',
    _extends({}, other, {
      className: (0, _reactUtils.classNames)('media', 'private-media', ALIGNMENT_TYPES[align], { 'private-media--collapsed': collapsed }, className) }),
    children
  );
}

UIMedia.propTypes = {
  align: _react.PropTypes.oneOf((0, _underscore.keys)(ALIGNMENT_TYPES)).isRequired,
  children: _react.PropTypes.node.isRequired,
  className: _react.PropTypes.string,
  collapsed: _react.PropTypes.bool.isRequired
};

UIMedia.defaultProps = {
  align: 'start',
  collapsed: false
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.348/js/layout/UIMedia.js
// module id = 252
// module chunks = 0 1